// @generated by protoc-gen-connect-query v0.4.1
// @generated from file admin/v1/inventory.proto (package admin.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { createQueryService } from "@bufbuild/connect-query";
import { MethodKind } from "@bufbuild/protobuf";
import { CreateDataDomainRequest, CreateDataDomainResponse, CreateInventoryObjectRequest, CreateInventoryObjectResponse, CreateInventoryTagRequest, CreateInventoryTagResponse, DeleteDataDomainRequest, DeleteDataDomainResponse, DeleteInventoryObjectRequest, DeleteInventoryObjectResponse, DeleteInventoryTagRequest, DeleteInventoryTagResponse, GetDataDomainByIdRequest, GetDataDomainByIdResponse, GetDataDomainsRequest, GetDataDomainsResponse, GetInventoryFlatOldRequest, GetInventoryFlatOldResponse, GetInventoryFlatRequest, GetInventoryFlatResponse, GetInventoryHierarchicalRequest, GetInventoryHierarchicalResponse, GetInventoryObjectRequest, GetInventoryObjectResponse, GetInventoryRequest, GetInventoryResponse, GetInventoryTagsRequest, GetInventoryTagsResponse, UpdateColumnDataLabelRequest, UpdateColumnDataLabelResponse, UpdateColumnFieldEncryptionRequest, UpdateColumnFieldEncryptionResponse, UpdateColumnLockStatusRequest, UpdateColumnLockStatusResponse, UpdateDataDomainRequest, UpdateDataDomainResponse, UpdateInventoryObjectTagsRequest, UpdateInventoryObjectTagsResponse } from "@buf/formal_admin.bufbuild_es/admin/v1/inventory_pb.js";

export const typeName = "admin.v1.InventoryService";

/**
 * @generated from rpc admin.v1.InventoryService.GetInventoryHierarchical
 */
export const getInventoryHierarchical = createQueryService({
  service: {
    methods: {
      getInventoryHierarchical: {
        name: "GetInventoryHierarchical",
        kind: MethodKind.Unary,
        I: GetInventoryHierarchicalRequest,
        O: GetInventoryHierarchicalResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventoryHierarchical;

/**
 * @generated from rpc admin.v1.InventoryService.GetInventory
 */
export const getInventory = createQueryService({
  service: {
    methods: {
      getInventory: {
        name: "GetInventory",
        kind: MethodKind.Unary,
        I: GetInventoryRequest,
        O: GetInventoryResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventory;

/**
 * @generated from rpc admin.v1.InventoryService.GetInventoryFlat
 */
export const getInventoryFlat = createQueryService({
  service: {
    methods: {
      getInventoryFlat: {
        name: "GetInventoryFlat",
        kind: MethodKind.Unary,
        I: GetInventoryFlatRequest,
        O: GetInventoryFlatResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventoryFlat;

/**
 * @generated from rpc admin.v1.InventoryService.GetInventoryFlatOld
 */
export const getInventoryFlatOld = createQueryService({
  service: {
    methods: {
      getInventoryFlatOld: {
        name: "GetInventoryFlatOld",
        kind: MethodKind.Unary,
        I: GetInventoryFlatOldRequest,
        O: GetInventoryFlatOldResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventoryFlatOld;

/**
 * @generated from rpc admin.v1.InventoryService.GetInventoryObject
 */
export const getInventoryObject = createQueryService({
  service: {
    methods: {
      getInventoryObject: {
        name: "GetInventoryObject",
        kind: MethodKind.Unary,
        I: GetInventoryObjectRequest,
        O: GetInventoryObjectResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventoryObject;

/**
 * @generated from rpc admin.v1.InventoryService.UpdateColumnLockStatus
 */
export const updateColumnLockStatus = createQueryService({
  service: {
    methods: {
      updateColumnLockStatus: {
        name: "UpdateColumnLockStatus",
        kind: MethodKind.Unary,
        I: UpdateColumnLockStatusRequest,
        O: UpdateColumnLockStatusResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).updateColumnLockStatus;

/**
 * @generated from rpc admin.v1.InventoryService.UpdateColumnDataLabel
 */
export const updateColumnDataLabel = createQueryService({
  service: {
    methods: {
      updateColumnDataLabel: {
        name: "UpdateColumnDataLabel",
        kind: MethodKind.Unary,
        I: UpdateColumnDataLabelRequest,
        O: UpdateColumnDataLabelResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).updateColumnDataLabel;

/**
 * @generated from rpc admin.v1.InventoryService.UpdateColumnFieldEncryption
 */
export const updateColumnFieldEncryption = createQueryService({
  service: {
    methods: {
      updateColumnFieldEncryption: {
        name: "UpdateColumnFieldEncryption",
        kind: MethodKind.Unary,
        I: UpdateColumnFieldEncryptionRequest,
        O: UpdateColumnFieldEncryptionResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).updateColumnFieldEncryption;

/**
 * @generated from rpc admin.v1.InventoryService.UpdateInventoryObjectTags
 */
export const updateInventoryObjectTags = createQueryService({
  service: {
    methods: {
      updateInventoryObjectTags: {
        name: "UpdateInventoryObjectTags",
        kind: MethodKind.Unary,
        I: UpdateInventoryObjectTagsRequest,
        O: UpdateInventoryObjectTagsResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).updateInventoryObjectTags;

/**
 * @generated from rpc admin.v1.InventoryService.CreateInventoryObject
 */
export const createInventoryObject = createQueryService({
  service: {
    methods: {
      createInventoryObject: {
        name: "CreateInventoryObject",
        kind: MethodKind.Unary,
        I: CreateInventoryObjectRequest,
        O: CreateInventoryObjectResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).createInventoryObject;

/**
 * @generated from rpc admin.v1.InventoryService.DeleteInventoryObject
 */
export const deleteInventoryObject = createQueryService({
  service: {
    methods: {
      deleteInventoryObject: {
        name: "DeleteInventoryObject",
        kind: MethodKind.Unary,
        I: DeleteInventoryObjectRequest,
        O: DeleteInventoryObjectResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).deleteInventoryObject;

/**
 * @generated from rpc admin.v1.InventoryService.CreateInventoryTag
 */
export const createInventoryTag = createQueryService({
  service: {
    methods: {
      createInventoryTag: {
        name: "CreateInventoryTag",
        kind: MethodKind.Unary,
        I: CreateInventoryTagRequest,
        O: CreateInventoryTagResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).createInventoryTag;

/**
 * @generated from rpc admin.v1.InventoryService.GetInventoryTags
 */
export const getInventoryTags = createQueryService({
  service: {
    methods: {
      getInventoryTags: {
        name: "GetInventoryTags",
        kind: MethodKind.Unary,
        I: GetInventoryTagsRequest,
        O: GetInventoryTagsResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getInventoryTags;

/**
 * @generated from rpc admin.v1.InventoryService.DeleteInventoryTag
 */
export const deleteInventoryTag = createQueryService({
  service: {
    methods: {
      deleteInventoryTag: {
        name: "DeleteInventoryTag",
        kind: MethodKind.Unary,
        I: DeleteInventoryTagRequest,
        O: DeleteInventoryTagResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).deleteInventoryTag;

/**
 * @generated from rpc admin.v1.InventoryService.CreateDataDomain
 */
export const createDataDomain = createQueryService({
  service: {
    methods: {
      createDataDomain: {
        name: "CreateDataDomain",
        kind: MethodKind.Unary,
        I: CreateDataDomainRequest,
        O: CreateDataDomainResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).createDataDomain;

/**
 * @generated from rpc admin.v1.InventoryService.GetDataDomains
 */
export const getDataDomains = createQueryService({
  service: {
    methods: {
      getDataDomains: {
        name: "GetDataDomains",
        kind: MethodKind.Unary,
        I: GetDataDomainsRequest,
        O: GetDataDomainsResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getDataDomains;

/**
 * @generated from rpc admin.v1.InventoryService.GetDataDomainById
 */
export const getDataDomainById = createQueryService({
  service: {
    methods: {
      getDataDomainById: {
        name: "GetDataDomainById",
        kind: MethodKind.Unary,
        I: GetDataDomainByIdRequest,
        O: GetDataDomainByIdResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).getDataDomainById;

/**
 * @generated from rpc admin.v1.InventoryService.UpdateDataDomain
 */
export const updateDataDomain = createQueryService({
  service: {
    methods: {
      updateDataDomain: {
        name: "UpdateDataDomain",
        kind: MethodKind.Unary,
        I: UpdateDataDomainRequest,
        O: UpdateDataDomainResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).updateDataDomain;

/**
 * @generated from rpc admin.v1.InventoryService.DeleteDataDomain
 */
export const deleteDataDomain = createQueryService({
  service: {
    methods: {
      deleteDataDomain: {
        name: "DeleteDataDomain",
        kind: MethodKind.Unary,
        I: DeleteDataDomainRequest,
        O: DeleteDataDomainResponse,
      },
    },
    typeName: "admin.v1.InventoryService",
  },
}).deleteDataDomain;
